<template>
  <img :src="url" alt="刷新重新加载..." />
</template>
<script>
export default {
  name: "imgComp",
  props: {
    src: {
      type: String,
      required: false,
      default: () => {
        return this.url;
      },
    },
  }, // 父组件传过来所需的url
  data() {
    return {
      // url: require("../../public/img/indexBg/loading.gif"), // 本地的 loading.gif
      url: "https://pic.imgdb.cn/item/65abdd55871b83018af558ee.gif",
    };
  },
  mounted() {
    var newImg = new Image();
    newImg.src = this.src;
    newImg.onerror = () => {
      // 图片加载错误时的替换图片
      newImg.src = this.url;
    };
    newImg.onload = () => {
      // 图片加载成功后把地址给原来的img
      this.url = newImg.src;
    };
  },
};
</script>
